import {
  ONLINE_ORDER_ALL,
  ONLINE_ORDER_CREATE,
  ONLINE_ORDER_GET,
  ONLINE_ORDER_DEL,
  ONLINE_ORDER_PUT,
  ONLINE_ORDER_LOADING,
  ONLINE_ORDER_ERROR,
  // eslint-disable-next-line import/named
} from '../../actions/types';

const initialState = {
  onlineOrder: null,
  isLoading: true,
  isCompleted: false,
};
// eslint-disable-next-line func-names
export default function (state = initialState, action) {
  switch (action.type) {
    case ONLINE_ORDER_LOADING:
      return { isLoading: true, isCompleted: true };
    case ONLINE_ORDER_ERROR:
      return { isLoading: false, isCompleted: false, ...action.payload };
    case ONLINE_ORDER_ALL:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case ONLINE_ORDER_GET:
      return {
        ...action.payload,
        isLoading: false,
        isCompleted: true,
      };
    case ONLINE_ORDER_CREATE:
      return { isLoading: false, isCompleted: true };
    case ONLINE_ORDER_PUT:
      return { isLoading: false, isCompleted: true };
    case ONLINE_ORDER_DEL:
      return { isLoading: false, isCompleted: true };
    default:
      return state;
  }
}
